import React, { useEffect, useState } from "react";
import css from "./Identifier.module.css";
import { useSession } from "../../../../hooks/session";
import Spinner from "../../../Spinner";
import { useLookUp } from "../../../../hooks/lookup";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Identifier = ({ sessionId, layoutFns }) => {
  const { lookup } = useLookUp();
  const [isLoadingConversion, setLoadingConversion] = useState(false);
  const [toggleCurrentPositions, setToggleCurrentPositions] = useState(false);
  const { data, isLoading } = useSession(sessionId);
  const [proteinType, setProteinType] = useState(
    isLoading ? null : data.protein_type
  );

  const onClickToggle = () => {
    setToggleCurrentPositions(!toggleCurrentPositions);
  };

  useEffect(() => {
    setLoadingConversion(false);
  }, [sessionId]);

  if (isLoading) return <Spinner />;

  return (
    <div className={css.identifier}>
      <h2 className={css.changeIdentifierH2}>Identifier Conversion</h2>
      <form
        className={css.formIdentifier}
        onSubmit={(event) => {
          event.preventDefault();
          setLoadingConversion(true);
          lookup(
            data.species,
            data.database,
            data.nativeId,
            data.network_type,
            proteinType,
            {},
            saveCurrentPositions(
              toggleCurrentPositions,
              data.network_type,
              layoutFns.getCyElements()
            )
          );
        }}
      >
        <div className={css.proteinID}>
          <label className={css.labelProteinID}>Node Type: </label>
          <select
            className={css.selectProteinID}
            value={proteinType}
            onChange={(event) => {
              setProteinType(event.currentTarget.value);
            }}
          >
            {data.allowed_conversion.map((choice) => (
              <option key={choice.value} value={choice.value}>
                {choice.name in labelIdentifiers
                  ? labelIdentifiers[choice.name]
                  : choice.name}
              </option>
            ))}
          </select>
        </div>
        <div
          style={{
            display: "grid",
            width: "50%",
            gridTemplateColumns: "auto auto",
          }}
        >
          <span style={{ placeSelf: "center" }}>Keep current positions: </span>
          <span style={{ placeSelf: "center", cursor: "pointer" }}>
            <FontAwesomeIcon
              size={"2x"}
              onClick={onClickToggle}
              icon={toggleCurrentPositions ? "toggle-on" : "toggle-off"}
              color={toggleCurrentPositions ? "#4169e1" : "lightgray"}
            />
          </span>
        </div>
        <Button
          variant="primary"
          disabled={isLoadingConversion || data.protein_type === proteinType}
          type={"submit"}
        >
          {isLoadingConversion ? "Loading…" : "Convert"}
        </Button>
      </form>
    </div>
  );
};

export default Identifier;

const saveCurrentPositions = (
  toggleCurrentPositions,
  network_type,
  cyElements
) => {
  if (toggleCurrentPositions) {
    let position = {};
    for (let i = 0; i < cyElements.length; i++) {
      if (
        cyElements[i].group === "nodes" &&
        cyElements[i].data.node_type !== "powernode" &&
        cyElements[i].data.node_type !== "compartment"
      ) {
        position[cyElements[i].data.native] = {
          position: cyElements[i].position,
        };
      }
    }
    return { network_type: network_type, data: position };
  } else {
    return {};
  }
};

export const labelIdentifiers = {
  NATIVE: "Native",
  ALIAS: "Alias",
  ENSEMBL: "Ensembl Gene",
  ENSEMBL_PROT: "Ensembl Prot",
  ENSEMBL_TRANS: "Ensembl Trans",
  ENTREZID: "EntrezID",
  ENZYME: "Enzyme",
  FLYBASE: "Flybase",
  FLYBASECG: "FlybaseCG",
  ORF: "Orf",
  PFAM: "Pfam",
  REFSEQ: "Refseq",
  SGD: "Sgd",
  SYMBOL: "Gene Symbol",
  TAIR: "Tair",
  UNIPROT: "Uniprot",
  WORMBASE: "Wormbase",
  ZFIN: "Zfin",
};
